<script>
import { Line, mixins } from "vue-chartjs";
const { reactiveProp } = mixins;

export default {
  extends: Line,
  mixins: [reactiveProp],
  props: ["data", "options", "height"],
  mounted() {
    this.renderChart(this.chartData, this.options);
  }
};
</script>

<template>
  <div :style="{ height: height + 'px' }">
    <canvas ref="canvas"></canvas>
  </div>
</template>